import { ColoursObj, Icon } from '@eventr/common-storybook'
import { FC } from 'react'

export const CarouselSeeAllItineraries: FC = () => {
    function onClick() {
        window.pushPath('/account/itineraries')
    }

    return (
        <Icon
            name="Hamburger"
            iconColour={ColoursObj.shades.shade5}
            onClick={onClick}
        />
    )
}
